<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>首页</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>站点设置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">站点设置</span>
      </div>
      <div class="xcx-content">
        <el-form
          ref="form_data"
          :model="form_data"
          :rules="rules"
          label-width="160px"
          style="width: 80%"
        >
          <el-form-item label="站点标题：" prop="title">
            <el-input
              v-model="form_data.title"
              placeholder="请输入站点标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="分享关键词：" prop="keywords">
            <el-input
              v-model="form_data.keywords"
              placeholder="请输入分享关键词"
            ></el-input>
          </el-form-item>
          <el-form-item label="分享描述：" prop="description">
            <el-input
              v-model="form_data.description"
              type="textarea"
              placeholder="请输入分享描述"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="公众号二维码："
            prop="picture"
            class="txt_left kind_img"
          >
            <el-upload
              class="updata_img"
              accept="image/*"
              name="image"
              :on-exceed="descExceed"
              :limit="1"
              :on-remove="del_img"
              :action="upload_img_url"
              :file-list="form_data.picture"
              list-type="picture-card"
              :on-success="img_succ"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div style="font-size: 12px; color: #606266">
              为1:1比例图片 （不小于140 x 140px）
            </div>
          </el-form-item>
          <el-form-item
            label="客服二维码："
            prop="qrcode"
            class="txt_left kind_img"
          >
            <el-upload
              class="updata_img"
              accept="image/*"
              name="image"
              :on-exceed="descExceed"
              :limit="1"
              :on-remove="del_img2"
              :action="upload_img_url"
              :file-list="form_data.qrcode"
              list-type="picture-card"
              :on-success="img_succ2"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div style="font-size: 12px; color: #606266">
              为1:1比例图片 （不小于140 x 140px）
            </div>
          </el-form-item>
          <el-form-item class="mar_T_50">
            <el-button type="primary" @click="save()">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading:true,
      form_data: {
        title: "",
        keywords: "",
        description: "",
        wxqrcode: "",
        kfqrcode: "",
        picture: [],
        qrcode: [],
        id: 0,
      },
      upload_img_url: this.adminApi.upload_url,

      id: "",
      rules: {
        title: [{ required: true, message: "请输入站点标题", trigger: "blur" }],
        keywords: [
          { required: true, message: "请输入分享关键词", trigger: "blur" },
        ],
        description: [
          { required: true, message: "请输入分享描述", trigger: "blur" },
        ],
        picture: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
            type: "array",
            min: 1,
          },
        ],
        qrcode: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
            type: "array",
            min: 1,
          },
        ],
      },
    };
  },
  mounted() {
    var that = this;
    that.getDetail();
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios.post("/Config/site").then((res) => {
        if (res) {
          if (res.data) {
            that.form_data = res.data;
            that.form_data.picture = [
              {
                name: "img",
                url: res.data.wxqrcode,
              },
            ];
            that.form_data.qrcode = [
              {
                name: "img",
                url: res.data.kfqrcode,
              },
            ];
          }
          that.loading = false;
        }
      });
    },
    save() {
      const that = this;
      that.$refs.form_data.validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        if (that.form_data.picture.length == 0) {
          return that.$message.warning("请上传图片!");
        }
        formData = that.form_data;
        var url = "/Config/siteupdate";
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.$router.push("/Config/site");
        });
      });
    },
    descExceed: function (t, e) {
      this.$message.warning("只能上传一张图片哦!");
    },
    img_succ(res) {
      const that = this;
      that.form_data.picture = [
        {
          name: "img",
          url: res.msg,
        },
      ];
      that.form_data.wxqrcode = res.msg;
    },
    del_img(file, fileList) {
      this.form_data.picture = fileList;
    },
    img_succ2(res) {
      const that = this;
      that.form_data.kfqrcode = res.msg;
      that.form_data.qrcode = [
        {
          name: "img",
          url: res.msg,
        },
      ];
    },
    del_img2(file, fileList) {
      this.form_data.qrcode = fileList;
    },
  },
};
</script>
<style>
.kind_img .updata_img .el-upload-list__item-actions,
.kind_img .updata_img .el-upload-list__item-thumbnail,
.kind_img .updata_img .el-upload-list__item.is-success,
.kind_img .updata_img .el-upload-list__item.is-undefined,
.kind_img .updata_img .el-upload-list__item.is-uploading {
  width: 140px;
  height: 140px;
}
.kind_img .updata_img .el-upload.el-upload--picture-card {
  width: 140px;
  height: 140px;
  line-height: 150px;
}
</style>